import { render, staticRenderFns } from "./InboxNew.vue?vue&type=template&id=3e86cddd&scoped=true"
import script from "./InboxNew.vue?vue&type=script&lang=ts"
export * from "./InboxNew.vue?vue&type=script&lang=ts"
import style0 from "./InboxNew.vue?vue&type=style&index=0&id=3e86cddd&scoped=true&lang=css"
import style1 from "./InboxNew.vue?vue&type=style&index=1&id=3e86cddd&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e86cddd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e86cddd')) {
      api.createRecord('3e86cddd', component.options)
    } else {
      api.reload('3e86cddd', component.options)
    }
    module.hot.accept("./InboxNew.vue?vue&type=template&id=3e86cddd&scoped=true", function () {
      api.rerender('3e86cddd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inbox/InboxNew.vue"
export default component.exports